import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import toastr from 'toastr';
import { firebase } from '../../../actions/auth/firebase';
import { getProviderId, loginHistory } from '../../../actions/auth/loginHistory';
import { signOut } from '../../../actions/auth/signOut';
import { logoutAuth, selectAuth } from '../../../redux/AuthSlice';
import { resetInvoices } from '../../../redux/InvoicesSlice';
import { resetPaymentData } from '../../../redux/PaymentDataSlice';
import { updatePaymentReasons } from '../../../redux/PaymentReasonsSlice';
import { resetPayment } from '../../../redux/PaymentSlice';
import { selectPortalInfo } from '../../../redux/PortalInfoSlice';
import { updatePortals } from '../../../redux/PortalsSlice';
import { selectUser, updateUser } from '../../../redux/UserSlice';

const Logout = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const auth = useSelector(selectAuth);
  const user = useSelector(selectUser);
  const portalInfo = useSelector(selectPortalInfo);

  useEffect(() => {
    async function userSignOut() {
      try {
        await loginHistory({
          userId: user.id,
          portalId: portalInfo?.id,
          providerId: getProviderId(auth),
          action: 'logout',
        });
        await dispatch(logoutAuth());
        await signOut();
        await dispatch(updateUser({}));
        await dispatch(resetInvoices({}));
        await dispatch(resetPaymentData({}));
        await dispatch(updatePaymentReasons([]));
        await dispatch(updatePortals([]));
        await dispatch(resetPayment({}));
        await firebase.auth().signOut();
        localStorage.removeItem('user');
        return navigate(`/login`);
      } catch (error) {
        toastr.error(error);
      }
    }

    userSignOut();
  }, [dispatch, navigate, auth, portalInfo, user]);

  return <></>;
};

export default Logout;
